<script>
import fieldMixin from '@maison/mixins/fieldMixin';
import RadioField from '@maison/components/form/fields/RadioField';
import { useField } from '@phoenix/composables/field';

export default {
  components: {
    RadioField,
  },

  mixins: [fieldMixin],

  props: {
    inline: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    return useField(props);
  },

  computed: {
    fieldsetClasses() {
      return ['fieldset', 'fieldset--floating', `fieldset--${this.inline ? 'horizontal' : 'vertical'}`];
    },
  },

  methods: {
    getOptionAttrs(option) {
      return {
        name: this.field.name,
        required: this.field.required,
        scope: this.field.scope,
        ...option,
      };
    },
  },
};
</script>

<template>
  <fieldset :class="fieldsetClasses">
    <legend v-if="field.label && showLabel" class="fieldset__legend" v-html="field.label" />

    <div class="fieldset__fields">
      <radio-field
        v-for="option in field.options"
        :key="option.id"
        v-model="value"
        :parent-id="field.id"
        :attrs="getOptionAttrs(option)"
        :should-validate="false"
      />
    </div>
  </fieldset>
</template>
